import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';
import Home from '@/components/home.vue';
import Secure from '@/components/secure.vue';
import Auth from '@okta/okta-vue';
import CrosswalkCollectionMap from '@/components/CrosswalkCollectionMap.vue';
import CrosswalkCollectionList from '@/components/CrosswalkCollectionList.vue';
// import KMLTest from '@/components/KMLMap.vue';

Vue.use(Auth, {
  issuer: 'https://login.crossable.org/oauth2/default',
  client_id: '0oari0whmPlXJEpIS4x6',
  redirect_uri: window.location.origin.concat('/implicit/callback'),
  scope: 'openid profile email',
});

Vue.use(VueRouter);

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/implicit/callback',
    component: Auth.handleCallback(),
  },
  {
    path: '/secure',
    name: 'Secure',
    component: Secure,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  /* {
    path: '/kml',
    name: 'KMLTest',
    component: KMLTest,
  }, */
  {
    path: '/',
    name: 'CrosswalkCollectionMap',
    component: CrosswalkCollectionMap,
  },
  {
    path: '/list',
    name: 'CrosswalkCollectionList',
    component: CrosswalkCollectionList,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(Vue.prototype.$auth.authRedirectGuard());
Vue.prototype.$googleRef = null;
Vue.prototype.$markers = [];
Vue.prototype.$markerIndex = {};
export default router;
